<div class="chat-header-container fade-in">
  <div class="chat-type-container">
    <div>{{ title }}</div>
  </div>
  <div class="model-selector-container" *ngIf="modelSelector">
    <app-model-selector
      (modelSelected)="onModelSelected($event)"
    ></app-model-selector>
  </div>
</div>
